import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';

import {ApplicationState} from '../../application-state/store';
import {CustomerContactTypesActions} from '../store';
import {CustomerContactTypesSelectors} from '../store/selectors';

@Injectable()
export class CustomerContactTypesLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.customersLoaded().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  customersLoaded() {

    return this.store.pipe(
      select(CustomerContactTypesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(CustomerContactTypesActions.ReadCustomerContactTypes());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
